import React from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import RaisedButton from 'material-ui/RaisedButton';
import AutoComplete from 'material-ui/AutoComplete';
import TextField from 'material-ui/TextField';

import api from 'services';

class LUportBlock extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            ports: [],
            port: props.port,
            key: props.key,
            error: props.error,
            typeOfPort: props.typeOfPort,
        };

        this.dAutocomplete = _.debounce((searchText) => {
            if (searchText.length <= 2) {
                return;
            }

            api.findPortAdmin({ name: searchText, withAreas: true })
                .then((response) => {
                    const ports = [];

                    response.data.data.forEach((port) => {
                        ports.push(...this.createPort(port));
                    });

                    this.setState({
                        ports,
                    });
                })
                .catch(() => null);
        }, 1000);

        this.changeAutoComplete = this.changeAutoComplete.bind(this);
        this.chooseAutoComplete = this.chooseAutoComplete.bind(this);

        this.changeDetails = this.changeDetails.bind(this);
        this.handleAndOrChange = this.handleAndOrChange.bind(this);
    }

    changeDetails(e, value) {
        const { port } = this.state;

        port.details = value;
        
        this.setState({
            port,
        }, () => {
            this.props.changePort(
                this.props.portKey,
                this.props.typeOfPort,
                this.state.port,
            );
        });
    }

    createPort(port) {
        const ports = [];
        let name = '';

        if (port.sub) {
            port.sub.forEach((subPort) => {
                ports.push({
                    item: subPort,
                    text: `${subPort.name} - country ${port.country.name}`,
                    value: (
                        <MenuItem
                            primaryText={`${subPort.name} - country ${port.country.name}`}
                            value={subPort}
                            style={{ paddingLeft: '30px' }}
                        />
                    ),
                });
            });
        }

        if (port.country) {
            name = `${port.name} - country ${port.country.name}`;
        } else {
            name = port.name;
        }

        return [
            {
                item: port,
                text: name,
                value: (
                    <MenuItem
                        primaryText={name}
                        value={port}
                    />
                ),
            },
            ...ports,
        ];
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        this.setState({
            port: nextProps.port,
            key: nextProps.key,
            error: nextProps.error,
            typeOfPort: nextProps.typeOfPort,
        });
    }

    changeAutoComplete(searchText) {
        const { port } = this.state;
        port.portName = searchText;

        this.setState({
            port,
        }, () => {
            this.dAutocomplete(searchText);
        });
    }

    chooseAutoComplete(updateProperties) {
        if (!updateProperties) {
            return;
        }

        const { port } = this.state;
        port.port = updateProperties.item._id;
        port.portName = updateProperties.item.name;

        this.setState({
            port,
        }, () => {
            this.props.changePort(
                this.props.portKey,
                this.props.typeOfPort,
                this.state.port,
            );
        });
    }

    handleAndOrChange(e, i, value) {
        const { port } = this.state;

        port.andOr = value;
        
        this.setState({
            andOr: value,
        }, () => {
            this.props.changePort(
                this.props.portKey,
                this.props.typeOfPort,
                this.state.port,
            );
        });
    }

    render() {
        const {
            port, ports, typeOfPort, error, 
        } = this.state;

        const { removePort, portKey } = this.props;
        return (
            <React.Fragment>
                <div className='one-forth'>
                    <AutoComplete
                        errorText={error}
                        textFieldStyle={{ fontSize: '13px' }}
                        hintText={`${typeOfPort} port`}
                        searchText={port.portName}
                        dataSource={ports}
                        onUpdateInput={this.changeAutoComplete}
                        onNewRequest={this.chooseAutoComplete}
                        filter={AutoComplete.noFilter}
                        listStyle={{ overflow: 'auto', maxHeight: '300px', width: 'auto' }}
                        popoverProps={{
                            canAutoPosition: true,
                            style: {
                                width: '400px',
                            },
                        }}
                        fullWidth
                    />
                </div>
                <div className="one-forth">
                    <TextField
                        floatingLabelText='Details'
                        style={{ fontSize: '13px', marginTop: '-25px', width: 'auto' }}
                        value={port.details}
                        onChange={this.changeDetails}
                        fullWidth
                    />
                </div>
                {
                    this.props.portKey !== 0 ?
                        <React.Fragment>
                            <div className="one-forth">
                                <SelectField
                                    floatingLabelText="And/Or"
                                    value={port.andOr && port.andOr.charAt(0).toUpperCase() + port.andOr.slice(1)}
                                    onChange={this.handleAndOrChange}
                                    style={{ marginTop: '-25px', fontSize: '13px' }}
                                >
                                    <MenuItem value='And' primaryText="And" />
                                    <MenuItem value='Or' primaryText="Or" />
                                </SelectField>
                            </div>
                            <div className='one-forth'>
                                <RaisedButton 
                                    label="Remove Port"
                                    secondary
                                    style={{ height: '25px' }}
                                    buttonStyle={{ height: '25px', lineHeight: '25px' }}
                                    labelStyle={{ fontSize: '13px' }}
                                    onClick={() => { removePort(portKey, typeOfPort); }}
                                />
                            </div>
                        </React.Fragment>
                        :
                        <div className="one-forth">
                            <SelectField
                                floatingLabelText="And/Or"
                                value={port.andOr && port.andOr.charAt(0).toUpperCase() + port.andOr.slice(1)}
                                onChange={this.handleAndOrChange}
                                style={{ marginTop: '-25px', fontSize: '13px' }}
                                disabled
                            >
                                <MenuItem value='And' primaryText="And" />
                                <MenuItem value='Or' primaryText="Or" />
                            </SelectField>
                        </div>
                }

            </React.Fragment>
        );
    }
}

export default connect(
    (state, {
        port, error, portKey, typeOfPort, changePort, 
    }) => ({
        port,
        error,
        portKey,
        typeOfPort,
        changePort,
    }),
    dispatch => bindActionCreators({ }, dispatch),
)(LUportBlock);



// WEBPACK FOOTER //
// ./app/components/Letters/SingleNew/Cargo/Sidebar/Order/LUPorts/LUportBlock.jsx